import React, { useState } from 'react';
import './Landing.css';

export default function Landing({ onEnter }) {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  function handleSignup(e) {
    e.preventDefault();
    if(!email) return;
    setSubmitted(true);
  }

  const features = [
    { icon:'📈', title:'Live Charts', desc:'Multi-panel candlestick charts with VWAP, EMA, MACD, Bollinger Bands and more. 10 second to daily timeframes.' },
    { icon:'📋', title:'Paper Trader', desc:'Practice order execution styled exactly like thinkorswim, Webull, and Interactive Brokers. Zero risk, real experience.' },
    { icon:'📓', title:'Trade Journal', desc:'Log every trade. Track emotions, setups, R:R. Calendar view, stats dashboard, CSV import from any broker.' },
    { icon:'🔥', title:'Momentum Scanner', desc:'Real-time small cap scanner with float badges, RS scores, and urgency alerts. Never miss a runner.' },
    { icon:'📰', title:'Live News Feed', desc:'Market-moving news with urgency icons. Know what is moving before the crowd does.' },
    { icon:'👥', title:'Trading Rooms', desc:'Learn alongside other traders. Live mentorship rooms, classes, and community chat coming soon.' },
  ];

  const plans = [
    {
      name:'Free',
      price:'$0',
      period:'forever',
      color:'#30363d',
      features:['1 chart panel','Paper trading — all brokers','Basic trade journal','Demo market data','Small cap scanner','Community access'],
      cta:'Start Free',
      highlight:false,
    },
    {
      name:'Pro',
      price:'$29',
      period:'per month',
      color:'#2563eb',
      features:['Unlimited chart panels','All chart types & indicators','Full trade journal + CSV import','TRUE live market data','Advanced momentum scanner','Live news feed with alerts','Priority support'],
      cta:'Start Pro Free',
      highlight:true,
    },
    {
      name:'Family',
      price:'$49',
      period:'per month',
      color:'#7c3aed',
      features:['Everything in Pro','Up to 3 users','Shared watchlists','Family performance dashboard','PDT tracking per user','Early access to new features'],
      cta:'Start Family Free',
      highlight:false,
    },
  ];

  return (
    <div className="lp-page">
      {/* NAV */}
      <nav className="lp-nav">
        <div className="lp-nav-logo">
          <div className="lp-nav-icon">GT</div>
          <div>
            <div className="lp-nav-name">The Groove Trading</div>
            <div className="lp-nav-sub">Finally Finding the Groove</div>
          </div>
        </div>
        <div className="lp-nav-links">
          <a href="#features">Features</a>
          <a href="#platforms">Platforms</a>
          <a href="#pricing">Pricing</a>
        </div>
        <button className="lp-launch-btn" onClick={onEnter}>Launch Platform →</button>
      </nav>

      {/* HERO */}
      <section className="lp-hero">
        <div className="lp-hero-inner">
          <div className="lp-pdt-badge">🔥 PDT Rule Is Changing — Get Ready Now</div>
          <h1 className="lp-hero-h1">
            Finally Finding<br />
            <span className="lp-hero-accent">The Groove.</span>
          </h1>
          <p className="lp-hero-p">
            The only platform built for new traders that gives you <strong>true live market data</strong> to learn with,
            while letting you paper trade exactly like the real brokers.
            Learn the craft. Build the discipline. Find your groove.
          </p>
          <div className="lp-hero-btns">
            <button className="lp-btn-primary" onClick={onEnter}>Start Trading Free →</button>
            <button className="lp-btn-secondary" onClick={onEnter}>See the Platform</button>
          </div>
          <div className="lp-hero-stats">
            {[['$0','To get started'],['Live','Real-time data'],['3','Broker styles'],['$0','Commission']].map(([v,l])=>(
              <div key={l} className="lp-hstat">
                <div className="lp-hstat-val">{v}</div>
                <div className="lp-hstat-label">{l}</div>
              </div>
            ))}
          </div>
        </div>

        {/* FAKE PLATFORM PREVIEW */}
        <div className="lp-preview">
          <div className="lp-preview-bar">
            <div className="lp-preview-dots"><span></span><span></span><span></span></div>
            <div className="lp-preview-url">thegroovetrading.com</div>
          </div>
          <div className="lp-preview-body">
            <div className="lp-preview-sidebar">
              <div className="lp-psb-logo">GT</div>
              {['📈 Live Charts','📋 Paper Trader','📓 Journal','🔍 Scanner'].map((item,i)=>(
                <div key={item} className={`lp-psb-item ${i===0?'active':''}`}>{item}</div>
              ))}
            </div>
            <div className="lp-preview-main">
              <div className="lp-preview-topbar">
                <div className="lp-ptb-sym">AAPL</div>
                <div className="lp-ptb-sym">TSLA</div>
                <div className="lp-ptb-sym">GME 🔥</div>
                <div className="lp-ptb-badge">2×2</div>
              </div>
              <div className="lp-preview-charts">
                {[
                  {sym:'AAPL',price:'$187.42',chg:'+1.23%',color:'#22c55e'},
                  {sym:'TSLA',price:'$174.91',chg:'-2.14%',color:'#ef4444'},
                  {sym:'GME', price:'$14.72', chg:'+18.4%',color:'#22c55e'},
                  {sym:'NVDA',price:'$487.22',chg:'+3.81%',color:'#22c55e'},
                ].map(c=>(
                  <div key={c.sym} className="lp-mini-chart">
                    <div className="lp-mc-header">
                      <span className="lp-mc-sym">{c.sym}</span>
                      <span className="lp-mc-price">{c.price}</span>
                      <span className="lp-mc-chg" style={{color:c.color}}>{c.chg}</span>
                    </div>
                    <div className="lp-mc-canvas">
                      <svg viewBox="0 0 120 50" preserveAspectRatio="none" style={{width:'100%',height:'100%'}}>
                        <polyline
                          points={c.color==='#22c55e'
                            ? "0,40 15,35 25,38 35,25 45,28 55,20 65,15 75,18 85,12 95,8 105,5 120,3"
                            : "0,10 15,12 25,8 35,18 45,15 55,22 65,28 75,25 85,32 95,38 105,42 120,45"}
                          fill="none" stroke={c.color} strokeWidth="1.5"
                        />
                      </svg>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PDT SECTION */}
      <section className="lp-pdt-section" id="pdt">
        <div className="lp-pdt-inner">
          <div className="lp-pdt-badge-big">📋 Important for New Traders</div>
          <h2 className="lp-pdt-h2">The PDT Rule Is Changing.</h2>
          <p className="lp-pdt-p">
            The Pattern Day Trader rule has kept many new traders from building real skills. That is about to change.
            When it does, thousands of new traders are going to flood the market — and most of them will not be prepared.
          </p>
          <div className="lp-pdt-cards">
            <div className="lp-pdt-card">
              <div className="lp-pdt-card-icon">⚠️</div>
              <div className="lp-pdt-card-title">The Problem with Free Brokers</div>
              <div className="lp-pdt-card-desc">Robinhood, Webull, and other commission-free brokers give you 15-minute delayed data. You are trading blind. Missing the real move. Learning bad habits with fake prices.</div>
            </div>
            <div className="lp-pdt-card highlight">
              <div className="lp-pdt-card-icon">✅</div>
              <div className="lp-pdt-card-title">The Groove Trading Solution</div>
              <div className="lp-pdt-card-desc">Practice with TRUE live data here. See the real price action. Learn real setups. Then execute on whatever free broker you use. Best of both worlds.</div>
            </div>
            <div className="lp-pdt-card">
              <div className="lp-pdt-card-icon">🎯</div>
              <div className="lp-pdt-card-title">Be Ready When It Changes</div>
              <div className="lp-pdt-card-desc">The traders who practice now with real data will have a massive edge when the PDT rule changes. Do not show up to the market unprepared.</div>
            </div>
          </div>
        </div>
      </section>

      {/* FEATURES */}
      <section className="lp-features" id="features">
        <div className="lp-section-inner">
          <div className="lp-section-label">Everything You Need</div>
          <h2 className="lp-section-h2">Built for traders who are serious about getting better.</h2>
          <div className="lp-features-grid">
            {features.map(f=>(
              <div key={f.title} className="lp-feature-card">
                <div className="lp-fc-icon">{f.icon}</div>
                <div className="lp-fc-title">{f.title}</div>
                <div className="lp-fc-desc">{f.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PLATFORMS */}
      <section className="lp-platforms" id="platforms">
        <div className="lp-section-inner">
          <div className="lp-section-label">Three Platforms. One Login.</div>
          <h2 className="lp-section-h2">Practice on all three broker styles.</h2>
          <div className="lp-broker-cards">
            {[
              {name:'thinkorswim',icon:'ToS',color:'#7b2fff',desc:'All order types including MOC, LOC, trailing stops, and extended hours. The most powerful paper trading simulation available.'},
              {name:'Webull',icon:'WB',color:'#00b2ff',desc:'Clean mobile-first order entry. Trailing stop %, extended hours, and the exact workflow Webull users know.'},
              {name:'Interactive Brokers',icon:'IB',color:'#e63946',desc:'Advanced order types including VWAP, TWAP, Adaptive IBALGO, Midprice, and the full IBKR professional suite.'},
            ].map(b=>(
              <div key={b.name} className="lp-broker-card">
                <div className="lp-bc-icon" style={{background:b.color}}>{b.icon}</div>
                <div className="lp-bc-name">{b.name}</div>
                <div className="lp-bc-desc">{b.desc}</div>
                <div className="lp-bc-pill">Paper Mode Available</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PRICING */}
      <section className="lp-pricing" id="pricing">
        <div className="lp-section-inner">
          <div className="lp-section-label">Simple Pricing</div>
          <h2 className="lp-section-h2">Start free. Upgrade when you're ready.</h2>
          <div className="lp-pricing-grid">
            {plans.map(plan=>(
              <div key={plan.name} className={`lp-plan ${plan.highlight?'highlight':''}`}>
                {plan.highlight && <div className="lp-plan-badge">Most Popular</div>}
                <div className="lp-plan-name">{plan.name}</div>
                <div className="lp-plan-price">{plan.price}<span className="lp-plan-period">/{plan.period}</span></div>
                <ul className="lp-plan-features">
                  {plan.features.map(f=><li key={f}><span className="lp-check">✓</span>{f}</li>)}
                </ul>
                <button
                  className={`lp-plan-btn ${plan.highlight?'primary':''}`}
                  onClick={onEnter}
                  style={plan.highlight?{}:{borderColor:plan.color,color:plan.color}}
                >
                  {plan.cta}
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* EMAIL SIGNUP */}
      <section className="lp-signup">
        <div className="lp-signup-inner">
          <h2 className="lp-signup-h2">Ready to find your groove?</h2>
          <p className="lp-signup-p">Join traders who are getting ready for the PDT rule change. Start free today.</p>
          {submitted ? (
            <div className="lp-signup-success">🎵 You're on the list! We'll be in touch soon.</div>
          ) : (
            <form className="lp-signup-form" onSubmit={handleSignup}>
              <input
                className="lp-signup-input"
                type="email"
                placeholder="Enter your email..."
                value={email}
                onChange={e=>setEmail(e.target.value)}
              />
              <button className="lp-signup-btn" type="submit">Get Early Access →</button>
            </form>
          )}
          <button className="lp-enter-btn" onClick={onEnter}>Or launch the platform now — no signup required</button>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="lp-footer">
        <div className="lp-footer-logo">
          <div className="lp-nav-icon" style={{width:28,height:28,fontSize:10}}>GT</div>
          <div>
            <div style={{fontWeight:700,color:'#e6edf3',fontSize:13}}>The Groove Trading</div>
            <div style={{fontSize:10,color:'#484f58'}}>Finally Finding the Groove</div>
          </div>
        </div>
        <div className="lp-footer-links">
          <a href="#features">Features</a>
          <a href="#pricing">Pricing</a>
          <a href="#pdt">PDT Rule</a>
          <span style={{color:'#484f58'}}>thegroovetrading.com</span>
        </div>
        <div className="lp-footer-disclaimer">
          The Groove Trading is an educational paper trading platform. Not financial advice. Past performance does not guarantee future results. All trading involves risk.
        </div>
      </footer>
    </div>
  );
}